import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getOptimizedImageUrl } from '../lib/utils';

export default function Hero({ title, subtitle, image, showCta = true, isHome = false, ctas }) {
  const heightClass = isHome 
    ? "min-h-[calc(100vh-100px)]" 
    : "h-[350px] sm:h-[60vh] sm:min-h-[450px]";

  const heroCtas = ctas || [
    { label: 'Kontakt', href: '/kontakt', variant: 'primary' },
    { label: 'Ydelser', href: '/services/offshore-vind', variant: 'secondary' },
  ];

  return (
    <div className={`relative flex items-center justify-center overflow-hidden ${heightClass}`}>
      <div className="absolute inset-0 z-0">
        <img
          src={getOptimizedImageUrl(image, 1600, 85)}
          srcSet={`${getOptimizedImageUrl(image, 640, 85)} 640w, ${getOptimizedImageUrl(image, 1024, 85)} 1024w, ${getOptimizedImageUrl(image, 1600, 85)} 1600w, ${getOptimizedImageUrl(image, 1920, 85)} 1920w`}
          sizes="100vw"
          alt={title ? `Porthos Maritime - ${title.replace(/\n/g, ' ')}` : "Porthos Maritime - Professionel maritim rådgivning og support"}
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-slate-950/65"></div>
      </div>

      <div className="relative z-10 max-w-5xl px-4 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-blue-300 font-bold uppercase tracking-[0.3em] mb-4 text-sm sm:text-base"
        >
          Porthos Maritime
        </motion.p>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-3xl sm:text-5xl lg:text-7xl font-bold text-white uppercase tracking-tight mb-4 sm:mb-8 leading-tight px-2 whitespace-pre-line"
        >
          {title}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-base sm:text-xl text-slate-200 mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-4"
        >
          {subtitle}
        </motion.p>

        {showCta && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center px-6 pt-2"
            aria-label="Primære CTA-knapper på forsiden"
          >
            {heroCtas.map((cta) => (
              <Link
                key={cta.label}
                to={cta.href}
                className={cta.variant === 'primary'
                  ? "bg-blue-700 text-white px-6 py-3 sm:px-10 sm:py-4 uppercase font-bold tracking-widest text-xs sm:text-sm hover:bg-blue-800 transition-all transform hover:scale-105 shadow-xl shadow-slate-950/20"
                  : "bg-white/10 border-2 border-white text-white px-6 py-3 sm:px-10 sm:py-4 uppercase font-bold tracking-widest text-xs sm:text-sm hover:bg-white hover:text-slate-900 transition-all transform hover:scale-105 shadow-xl shadow-slate-950/20"
                }
              >
                {cta.label}
              </Link>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
}
